export default __webpack_public_path__ + "static/media/twitter.e4c86948.svg";